import { titleize } from '@/helper/helper'
export const routes = [
  {
    path: '/',
    name: 'Homepage',
    component: () => import('@/views/Posts.vue'),
    meta: { requiresAuth: true, footerIcon: 'home', titleName: route => {} }
  },
  {
    path: '/authors/:name',
    component: () => import('@/components/Routable.vue'),
    children: [
      {
        path: '/',
        name: 'Mixed',
        component: () => import('@/views/MixedView/index.vue'),
        props: route => ({
          actionProps: {
            mainAction: 'GET_NEXT_AUTHORS',
            resetAction: 'RESET_AUTHORS_ACTION'
          },
          getterProps: ['getAuthorPostsData', 'getAuthorPostsRefs'],
          actionParamsProps: route.params.name
        }),
        meta: {
          requiresAuth: true,
          footerIcon: 'home',
          titleName: route => route.params.name
        }
      },
      {
        path: 'posts/:postId',
        name: 'SinglePostAuthor',
        component: () => import('@/views/singlePost.vue'),
        meta: {
          requiresAuth: true,
          footerIcon: 'home',
          titleName: route => 'Noticia'
        }
      }
    ]
  },
  {
    path: '/posts/:postId', // postId
    name: 'SinglePost',
    component: () => import('@/views/singlePost.vue'),
    meta: {
      requiresAuth: true,
      footerIcon: 'home',
      titleName: route => 'Noticia'
    }
  },
  {
    path: '/tags/:name',
    name: 'MixedTag',
    component: () => import('@/views/MixedView/index.vue'),
    props: route => ({
      actionProps: {
        mainAction: 'GET_NEXT_TAGS',
        resetAction: 'RESET_TAGS_ACTION'
      },
      getterProps: ['getTagPostsData', 'getTagPostsRefs'],
      actionParamsProps: route.params.name
    }),
    meta: {
      requiresAuth: true,
      footerIcon: 'home',
      titleName: route => `#${titleize(route.params.name)}`
    }
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/router/posts.js